export default __webpack_public_path__ + "static/media/passLogo.717c6e18.svg";